export default __webpack_public_path__ + "static/media/viewOn.ac735f53.svg";